import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {SharedModule} from 'app/shared/shared.module';
import { MobileMenuComponent } from './mobile-menu.component';

@NgModule({
    declarations: [
        MobileMenuComponent
    ],
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        SharedModule
    ],
    exports: [
        MobileMenuComponent
    ]
})
export class MobileMenuModule {
}
